import { EventBus } from "@/services/EventBus";
import IconCam from "@/components/iconCam/IconCam.vue";
import { getViewName } from "@/utils";

export default {
  name: "Cam",
  data() {
    return {};
  },
  props: {
    cam: {
      type: Object
    },
    draggable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    inMap: {
      type: Boolean,
      default: false
    },
    notHover: {
      type: Boolean,
      default: false
    },
    notContraction: {
      type: Boolean,
      default: false
    },
    notViews: {
      type: Boolean,
      default: false
    },
    hovered: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    status() {
      const { cam } = this;
      return (cam && cam.status && cam.status.state) || null;
    }
  },
  methods: {
    dragStart() {
      if (this.selected || !this.draggable) return false;

      EventBus.$emit("cam:dragstart");
    },
    dragEnd() {
      EventBus.$emit("cam:dragend");
    },
    selectView(view) {
      this.$store.commit("setGrid", view.grid);
      this.$router.push({ name: "views", params: { viewId: view.id } });
    },
    getViewName
  },
  components: {
    IconCam
  }
};



// WEBPACK FOOTER //
// ./src/components/cam/cam.js